// src/v2/views/devices/mapManager.js

export function loadGoogleMapsApi({ apiKey, callback }) {
  if (window.google && window.google.maps) {
    callback();
    return;
  }
  if (document.getElementById('google-maps-script')) {
    document.getElementById('google-maps-script').addEventListener('load', callback);
    return;
  }
  const script = document.createElement('script');
  script.id = 'google-maps-script';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
  script.setAttribute('async', '');
  script.setAttribute('defer', '');
  script.onload = callback;
  document.head.appendChild(script);
}

export class MapManager {
  constructor(mapRef) {
    this.mapRef = mapRef;
    this.map = null;
    this.markers = [];
  }

  initMap({ center = { lat: -34.6037, lng: -58.3816 }, zoom = 10, onReady }) {
    this.map = new window.google.maps.Map(this.mapRef, { 
      center, 
      zoom,
      mapTypeId: 'satellite',
      mapTypeControl: false,
      zoomControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });
    if (onReady) onReady(this.map);
  }

  addMarker({ lat, lng, title }) {
    if (!this.map) return;
    const marker = new window.google.maps.Marker({ position: { lat, lng }, map: this.map, title });
    this.markers.push(marker);
    return marker;
  }

  clearMarkers() {
    this.markers.forEach(m => m.setMap(null));
    this.markers = [];
  }

  updateMarkers(markerDataArray) {
    this.clearMarkers();
    markerDataArray.forEach(data => this.addMarker(data));
  }

  getMapInstance() {
    return this.map;
  }
}
